<div class="excel-handler">
  <div *ngIf="isLoading">Loading Excel file...</div>

  <div *ngIf="isError" class="error-message">
    <p>Error fetching or parsing the Excel file. Please try again later.</p>
  </div>
  <div *ngIf="data.length > 0">
    <ag-grid-angular
      class="ag-theme-alpine"
      style="width: 100%; height: 400px;"
      [columnDefs]="headData"
      [rowData]="data"
      [pagination]="true"
      [domLayout]="'autoHeight'"
      [gridOptions]="{
        defaultColDef: { resizable: true, sortable: true, filter: true }
      }"
    >
    </ag-grid-angular>
  </div>
</div>
